import styled from "styled-components";
import { getColor } from "views/resources/theme";

export const WizzardWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #fff;
	.steps-content {
		width: ${(props) => (props.lastStep && props.desktop ? "100%" : "90%")};
		display: ${(props) =>
			props.lastStep && props.desktop
				? props.isLoggedIn
					? props.fieldsExist
						? "flex"
						: "block"
					: "flex"
				: "block"};
		flex-direction: row-reverse;
	}
	.steps-action {
		width: 90%;
		padding-left: 8px;
	}
	.ant-steps {
		width: 80%;
		left: 60%;
	}
	.ant-steps-item-title::after {
		top: 19px;
		left: 60%;
	}
	.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
		padding-left: 8px;
	}
	.line__name-container {
		width: 90%;
		font-weight: 600;
		font-size: 16px;
		color: ${getColor("blue_bg")};
		font-family: "Montserrat", sans-serif;
	}
	.current-step-label {
		color: #8c8c8c;
		font-size: 12px;
	}

	padding-top: 16px;
`;
